import { Action } from '@ngrx/store';
import { Results, Result, Token, Comments, Comment } from '@usimweb/core/models';

export const LOAD_RESULT = '[Result] Load result';
export const LOAD_RESULT_SUCCESS = '[Result] Load result success';
export const LOAD_RESULT_FAILED = '[Result] Load result failed';

export const LOAD_CURVES = '[Result] Load curves';
export const LOAD_CURVES_SUCCESS = '[Result] Load curves success';
export const LOAD_CURVES_FAILED = '[Result] Load curves failed';

export const LOAD_TOKEN = '[Result] Load token';
export const LOAD_TOKEN_SUCCESS = '[Result] Load token success';
export const LOAD_TOKEN_FAILED = '[Result] Load token failed';

export const LOAD_PPX = '[Result] Load ppx';
export const LOAD_PPX_SUCCESS = '[Result] Load ppx success';
export const LOAD_PPX_FAILED = '[Result] Load ppx failed';

export const RETRY_VERSION = '[Result] Retry version';
export const RETRY_VERSION_SUCCESS = '[Result] Retry version success';
export const RETRY_VERSION_FAILED = '[Result] Retry version failed';

export const LOAD_VERSION_COMMENTS = '[Result] Load version comments';
export const LOAD_VERSION_COMMENTS_SUCCESS = '[Result] Load version comments success';
export const LOAD_VERSION_COMMENTS_FAILED = '[Result] Load version comments failed';

export const LOAD_PROJECTS_COMMENTS = '[Result] Load projects comments';
export const LOAD_PROJECTS_COMMENTS_SUCCESS = '[Result] Load projects comments success';
export const LOAD_PROJECTS_COMMENTS_FAILED = '[Result] Load projects comments failed';

export const ADD_COMMENTS = '[Result] Add comments';
export const ADD_COMMENTS_SUCCESS = '[Result] Add comments success';
export const ADD_COMMENTS_FAILED = '[Result] Add comments failed';

export const RM_COMMENTS = '[Result] Remove comments';
export const RM_COMMENTS_SUCCESS = '[Result] Remove comments success';
export const RM_COMMENTS_FAILED = '[Result] Remove comments failed';

export const CLEAR_RESULT = '[Result] Clear result';

export class LoadResult implements Action {
  readonly type = LOAD_RESULT;
  constructor(public payload: { uuid: string; filling: string }) {}
}

export class LoadResultSuccess implements Action {
  readonly type = LOAD_RESULT_SUCCESS;
  constructor(public payload: Results) {}
}

export class LoadResultFailed implements Action {
  readonly type = LOAD_RESULT_FAILED;
  constructor(public payload: any) {}
}

export class LoadCurves implements Action {
  readonly type = LOAD_CURVES;
  constructor(public payload: { uuid: string; filling: string }) {}
}

export class LoadCurvesSuccess implements Action {
  readonly type = LOAD_CURVES_SUCCESS;
  constructor(public payload: Result) {}
}

export class LoadCurvesFailed implements Action {
  readonly type = LOAD_CURVES_FAILED;
  constructor(public payload: any) {}
}

export class LoadToken implements Action {
  readonly type = LOAD_TOKEN;
  constructor(public payload: string) {}
}

export class LoadTokenSuccess implements Action {
  readonly type = LOAD_TOKEN_SUCCESS;
  constructor(public payload: Token) {}
}

export class LoadTokenFailed implements Action {
  readonly type = LOAD_TOKEN_FAILED;
  constructor(public payload: any) {}
}

export class LoadPpx implements Action {
  readonly type = LOAD_PPX;
  constructor(public payload: { uuid: string; name: string }) {}
}

export class LoadPpxSuccess implements Action {
  readonly type = LOAD_PPX;
  constructor(public payload: Token) {}
}

export class LoadPpxFailed implements Action {
  readonly type = LOAD_PPX;
  constructor(public payload: any) {}
}

export class RetryVersion implements Action {
  readonly type = RETRY_VERSION;
  constructor(public payload: string) {}
}

export class RetryVersionSuccess implements Action {
  readonly type = RETRY_VERSION_SUCCESS;
  constructor(public payload: any) {}
}

export class RetryVersionFailed implements Action {
  readonly type = RETRY_VERSION_FAILED;
  constructor(public payload: any) {}
}

export class LoadVersionComments implements Action {
  readonly type = LOAD_VERSION_COMMENTS;
  constructor(public payload: string) {}
}

export class LoadVersionsCommentsSuccess implements Action {
  readonly type = LOAD_VERSION_COMMENTS_SUCCESS;
  constructor(public payload: Comments[]) {}
}

export class LoadVersionsCommentsFailed implements Action {
  readonly type = LOAD_PROJECTS_COMMENTS_FAILED;
  constructor(public payload: any) {}
}

export class LoadProjectsComments implements Action {
  readonly type = LOAD_PROJECTS_COMMENTS;
  constructor(public payload: string) {}
}

export class LoadProjectsCommentsSuccess implements Action {
  readonly type = LOAD_PROJECTS_COMMENTS_SUCCESS;
  constructor(public payload: Comments[]) {}
}

export class LoadProjectsCommentsFailed implements Action {
  readonly type = LOAD_PROJECTS_COMMENTS_FAILED;
  constructor(public payload: any) {}
}

export class AddComments implements Action {
  readonly type = ADD_COMMENTS;
  constructor(public payload: { comment: Comment; version_uuid: string; project_uuid: string }) {}
}

export class AddCommentsSuccess implements Action {
  readonly type = ADD_COMMENTS_SUCCESS;
  constructor(public payload: Comments[]) {}
}

export class AddCommentsFailed implements Action {
  readonly type = ADD_COMMENTS_FAILED;
  constructor(public payload: any) {}
}

export class RmComments implements Action {
  readonly type = RM_COMMENTS;
  constructor(public payload: { uuid: string; comment_uuid: string }) {}
}

export class RmCommentsSuccess implements Action {
  readonly type = RM_COMMENTS_SUCCESS;
  constructor(public payload: Comments[]) {}
}

export class RmCommentsFailed implements Action {
  readonly type = RM_COMMENTS_FAILED;
  constructor(public payload: any) {}
}

export class ClearResult implements Action {
  readonly type = CLEAR_RESULT;
  constructor() {}
}

export type ResultActions =
  | LoadResult
  | LoadResultSuccess
  | LoadResultFailed
  | LoadCurves
  | LoadCurvesSuccess
  | LoadCurvesFailed
  | LoadToken
  | LoadTokenSuccess
  | LoadTokenFailed
  | LoadPpx
  | LoadPpxSuccess
  | LoadPpxFailed
  | LoadVersionComments
  | LoadVersionsCommentsSuccess
  | LoadVersionsCommentsFailed
  | LoadProjectsComments
  | LoadProjectsCommentsSuccess
  | LoadProjectsCommentsFailed
  | AddComments
  | AddCommentsSuccess
  | AddCommentsFailed
  | RmComments
  | RmCommentsSuccess
  | RmCommentsFailed
  | RetryVersion
  | RetryVersionSuccess
  | RetryVersionFailed
  | ClearResult;
